// Import environment configuration
// Note: This maintains backward compatibility while preparing for React Native
import { config } from '../config/environment';
import { buildApiRoutes } from '@tuneswell/shared/apiRoutes';

export const AppRoutes = {
  ActData: '/creator/acts/:id/data',
  ActEarnings: '/act-earnings/:id',
  ReviewsPage: '/music/:contentType/:contentId/reviews',
  AllReviewsPage: '/reviews/all',
  ActTransactionDetails: '/act-earnings/:id/transactions',
  ActEditProfile: '/creator/acts/:id/edit-profile',
  Credits: '/credits',
  TrackCredits: '/credits/track/:trackId',
  AlbumCredits: '/credits/album/:albumId',
  Browsing: '/browsing',
  Downloads: '/downloads',
  CreatorActMgmt: '/creator/acts/:id/dashboard',
  CreatorAdd: '/creator/add',
  CreatorDash: '/creatordash',
  CreatorListeningPortal: '/creator/listening-portal',
  ActListeningPortal: '/creator/acts/:id/listening-portal',
  CreatorDrafts: '/creator/drafts',
  CreatorPage: '/creator-page',
  CreatorEarnings: '/creator-earnings',
  CreatorCurationEarnings: '/creator/curation-earnings',
  CreatorData: '/creator/data',
  EarningsDetails: '/earnings-details',
  TransactionDetails: '/earnings/transactions',
  EarningsBySource: '/earnings/source/:source',
  TaxSummary: '/earnings/tax-summary',
  AlbumEarningsDetails: '/album-earnings-details',
  CreatorEditProfile: '/creator/editprofile',
  CreatorProfile: '/creator/profile',
  PublicCreatorProfile: '/creator/:slug/profile',
  CreatorAccountSettings: '/creator/account-settings',
  PodcasterDash: '/podcasterdash',
  PodcasterProfile: '/podcaster/profile',
  PublicPodcasterProfile: '/podcaster/:id/profile',
  PodcasterAccountSettings: '/podcaster/account-settings',
  PodcasterEditProfile: '/podcaster/editprofile',
  PodcasterDrafts: '/podcaster/drafts',
  PodcasterEarnings: '/podcaster-earnings',
  PodcasterCurationEarnings: '/podcaster/curation-earnings',
  PodcasterData: '/podcaster/data',
  PodcasterConnections: '/podcaster/connections',
  PodcasterListeningPortal: '/podcaster/listening-portal',
  PodcastUpload: '/podcaster/upload',
  PodcastManagement: '/podcaster/podcasts/:id',
  PodcastEpisodeManagement: '/podcaster/podcasts/:id/episodes/:episodeId',
  ListenerAccountSettings: '/listener/account-settings',
  EmailPreferences: '/email-preferences',
  ActAdd: '/act/add',
  AddActName: '/add/act/',
  AddActCreators: '/add/act/creators',
  AddActAvatar: '/add/act/avatar',
  AlbumList: '/album/list',
  AlbumEdit: '/album/edit',
  AlbumView: '/album/view',
  ListenerProfile: '/listener-profile',
  PublicListenerProfile: '/listener/:id/profile',
  ListenerPayments: '/listener-payments',
  ListenerDash: '/listener-dash',
  ListenerCurationManager: '/listener-curation-manager',
  ListenerCurationSettings: '/listener-curation-setting',
  ListenerEditProfile: '/listener-edit-profile',
  LoginPage: '/login',
  RegisterPage: '/register',
  SignupEmailListener: '/signup-email-listener',
  SignupListenerForm: '/signup-listener',
  SignupCreatorForm: '/signup-creator',
  SignupPodcasterForm: '/signup-podcaster',
  SignupLabelForm: '/signup-label',
  SignupCreatorName: '/signup-creator-name',
  SignupEmailCreator: '/signup-email-Creator',
  SignupAvatarCreator: '/signup-avatar-creator',
  SignupInitial: '/signup-initial',
  SignupListenerAddCredit: '/signup-listener-add-credit',
  SignupListenerPayment: '/signup-listener-payment',
  SignupDOB: '/signup-dob',
  SignupName: '/signup-name',
  SignupAvatar: '/signup-avatar',
  SongUploadForm: '/song-upload-form',
  ActSelection: '/creator/upload-music',
  UploadTypeSelection: '/creator/acts/:id/upload-type',
  ActMusicUpload: '/creator/acts/:id/upload',
  AboutTuneswell: '/about-tuneswell',
  AboutUs: '/about-us',
  PlatformStatistics: '/platform-statistics',
  TermsOfService: '/terms-of-service',
  PrivacyPolicy: '/privacy-policy',
  DmcaPolicy: '/dmca',
  Support: '/support',
  DesktopApp: '/desktop',
  LikesPage: '/likes',
  Library: '/library',
  LibraryCreators: '/library/creators',
  LibraryCurators: '/library/curators',
  LibraryActs: '/library/acts',
  AccountCreate: '/account-create',
  AudioPlayer: '/audio-player',
  AlbumAdd: '/album/edit/new',
  Search: '/search',
  Home1: '/home-pre-login',
  Home2: '/home-post-login',
  Feed: '/feed',
  Socials: '/socials',
  FollowRequests: '/follow-requests',
  StreamingRateCalculator: '/streaming-rate-calculator',
  CurationPayCalculator: '/curation-pay-calculator',
  RoyaltiesCalculator: '/royalties-calculator',
  Exclusives: '/exclusives',
  LandingPage: '/',
  AddSingle: '/add-single',
  NowPlaying: '/now-playing',
  NewReleasesPage: '/new-releases-page',
  ArtistsPage: '/artists-page',
  PlaylistsPage: '/playlists-page',
  PodcastsPage: '/podcasts-page',
  PodcastersPage: '/podcasters-page',
  CuratorsPage: '/curators-page',
  CreatorsPage: '/creators-page',
  LabelsPage: '/labels-page',
  AlbumsPage: '/albums',
  SinglesPage: '/singles',
  PublicPodcastPage: '/podcast/:slug',
  TopSongsPage: '/top-songs',
  AlbumRecommendationsPage: '/album-recommendations',
  RecommendedActsPage: '/recommended-acts',
  RecommendedCreatorsPage: '/recommended-creators',
  RecommendedSongsPage: '/recommended-songs',
  GenreBrowsePage: '/browse-by-genre',
  AlbumPage: '/album-page/:slug',
  SinglePage: '/single-page/:slug',
  ActPage: '/act-page/:slug',
  ActFollowersPage: '/act/:slug/followers',
  ActFollowingPage: '/act/:slug/following',
  
  // Act Management Routes
  CreateAct: '/creator/acts/create',
  ActManagement: '/creator/acts',
  ActEdit: '/creator/acts/:uuid/edit',
  ActVerification: '/creator/acts/:uuid/verify',
  PublicActProfile: '/acts/:slug',
  ActProfile: '/creator/acts/:id/profile',
  ActManage: '/creator/acts/:id/manage',
  
  // Playlist Management Routes
  PlaylistBuilder: '/playlist/create',
  PlaylistView: '/playlist/:id',
  PlaylistList: '/playlists',
  UserPlaylists: '/my-playlists',
  
  // History Routes
  History: '/history',
  HistoryList: '/history/list',
  
  // Queue Routes
  Queue: '/queue',
  
  // Messaging Routes
  Messages: '/messages',
  Conversation: '/messages/:id',
  
  // Connections Management Routes
  CreatorConnections: '/creator/connections',
  
  // Map Discovery Routes
  MapDiscovery: '/map-discovery',
  CreatorLocationManagement: '/creator/location-management',
  
  // Label Management Routes
  LabelDash: '/label-dash',
  LabelProfile: '/label/profile',
  PublicLabelProfile: '/label/:id/profile',
  LabelAccountSettings: '/label/account-settings',
  LabelInvitationAcceptance: '/label-invitation/:invitationId',
  LabelEditProfile: '/label/edit-profile',
  LabelEarnings: '/label-earnings',
  LabelDrafts: '/label/drafts',
  LabelCurationEarnings: '/label/curation-earnings',
  LabelConnections: '/label/connections',
  LabelActManagement: '/label/acts',
  LabelUserManagement: '/label/users',
  LabelListeningPortal: '/label/listening-portal',
  
  // Publisher Management Routes
  PublisherDash: '/publisher-dash',
  PublisherEarnings: '/publisher-earnings',
  PublisherUserManagement: '/publisher/user-management',
  PublisherStatistics: '/publisher/statistics',
  PublisherActs: '/publisher/acts',
  StartLabel: '/start-label',
  StartPublisher: '/start-publisher',
  StartArtistProfile: '/start-artist-profile',
  StartPodcast: '/start-podcast',
  AboutYou: '/about-you',
  PayoutSetupReturn: '/payout-setup',
  PublisherInvitationAcceptance: '/publisher-invitation/:invitationId',
  PublisherProfile: '/publisher/profile',
  PublicPublisherProfile: '/publisher/:id/profile',
  PublisherEditProfile: '/publisher/profile/edit',
  PublisherAccountSettings: '/publisher/account-settings',
  PublisherConnections: '/publisher/connections',
  PublisherListeningPortal: '/publisher/listening-portal',
  PublishersPage: '/publishers',
  SignupPublisherForm: '/signup-publisher',
}

// Export baseURL and apiBaseURL for backward compatibility
// New code should import from config/environment.js directly
export const baseURL = config.baseURL;
export const apiBaseURL = config.apiBaseURL;

// Utility function to construct full image URLs with optional size parameter
// size can be: 'small' (150x150), 'medium' (400x400), 'large' (800x800), or null (original)
export const getImageUrl = (imagePath, size = null, imageData = null) => {
  if (!imagePath) return null;
  
  // If size is specified and we have imageData with thumbnail fields, use thumbnail
  if (size && imageData) {
    // Try to find thumbnail field in imageData
    let thumbnailUrl = null;
    if (size === 'small') {
      thumbnailUrl = imageData.image_thumbnail_small || 
                     imageData.profile_image_thumbnail_small || 
                     imageData.profile_picture_thumbnail_small;
    } else if (size === 'medium') {
      thumbnailUrl = imageData.image_thumbnail_medium || 
                     imageData.profile_image_thumbnail_medium || 
                     imageData.profile_picture_thumbnail_medium;
    } else if (size === 'large') {
      thumbnailUrl = imageData.image_thumbnail_large || 
                     imageData.profile_image_thumbnail_large || 
                     imageData.profile_picture_thumbnail_large;
    }
    
    // For banners, use banner_thumbnail regardless of size
    if (!thumbnailUrl && (imageData.banner_image_thumbnail || imageData.banner_picture_thumbnail)) {
      thumbnailUrl = imageData.banner_image_thumbnail || imageData.banner_picture_thumbnail;
    }
    
    // If thumbnail exists, use it
    if (thumbnailUrl) {
      return getImageUrl(thumbnailUrl); // Recursively process thumbnail URL
    }
  }
  
  // If it's already a full URL (http/https), return as-is
  // This handles cloud storage URLs (e.g., Linode Object Storage)
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    // Check if URL points to production storage when we're in staging
    // This helps identify when database contains production URLs after data copy
    if (imagePath.includes('tuneswell-production-media') || 
        imagePath.includes('tuneswell-production') ||
        (imagePath.includes('linodeobjects.com') && imagePath.includes('production'))) {
      console.warn('getImageUrl: Detected production storage URL in staging environment:', imagePath);
      // In staging, you might want to convert production URLs to staging URLs
      // For now, we'll return as-is but log a warning
    }
    return imagePath;
  }
  
  // For local paths, construct the URL relative to baseURL
  // Remove leading slash if present to avoid double slashes
  let cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
  
  // Fix duplicate media/media paths
  if (cleanPath.includes('media/media/')) {
    cleanPath = cleanPath.replace(/media\/media\//g, 'media/');
  }
  
  // Handle case where path is like "media/filename.jpeg" (missing directory)
  // This happens when Django's .url returns /media/filename.jpeg for legacy data
  if (cleanPath.startsWith('media/')) {
    const afterMedia = cleanPath.substring(6); // Remove "media/" prefix
    // If what's after "media/" is just a filename (no directory), add profile_pictures/
    if (afterMedia && !afterMedia.includes('/')) {
      cleanPath = `media/profile_pictures/${afterMedia}`;
    }
  }
  
  // Handle case where only filename is provided (no directory, no media prefix)
  // Check if path contains a directory separator
  if (!cleanPath.includes('/') && !cleanPath.startsWith('media/')) {
    // It's just a filename - default to profile_pictures directory
    // This handles legacy data where only filenames were stored
    // Common directories: profile_pictures, banner_pictures, uploads/act_images, uploads/track_images, etc.
    cleanPath = `profile_pictures/${cleanPath}`;
  }
  
  // If path doesn't start with media/, add it
  // This handles cases where the path is just "uploads/..." or "profile_pictures/..."
  if (!cleanPath.startsWith('media/')) {
    cleanPath = `media/${cleanPath}`;
  }
  
  return `${baseURL}/${cleanPath}`;
};

// Utility function to check if an image URL is from an external domain
// that doesn't support CORS (like Linode Object Storage)
// Returns true if the image should use crossOrigin="anonymous" (same-origin or CORS-enabled)
// Returns false if the image is from an external domain without CORS support
export const shouldUseCrossOrigin = (imageUrl) => {
  if (!imageUrl) return false;
  
  // If it's not a full URL (relative path), it's served from same origin
  if (!imageUrl.startsWith('http://') && !imageUrl.startsWith('https://')) {
    return true;
  }
  
  try {
    const url = new URL(imageUrl);
    const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';
    
    // If same origin, use crossOrigin
    if (url.origin === currentOrigin) {
      return true;
    }
    
    // Check if it's from Linode Object Storage (doesn't support CORS for images)
    if (url.hostname.includes('linodeobjects.com')) {
      return false;
    }
    
    // For other external domains, assume they might support CORS
    // But be conservative - only use crossOrigin if we know it's safe
    // Default to false for external domains to avoid CORS errors
    return false;
  } catch (e) {
    // If URL parsing fails, default to false
    return false;
  }
};

// Utility function to construct full audio URLs
export const getAudioUrl = (audioPath) => {
  if (!audioPath) return null;
  if (audioPath.startsWith('http')) return audioPath;
  
  // Handle different path formats
  let cleanPath = audioPath;
  
  // Remove leading slash if present
  if (cleanPath.startsWith('/')) {
    cleanPath = cleanPath.slice(1);
  }
  
  // Fix duplicate media/media paths
  if (cleanPath.includes('media/media/')) {
    cleanPath = cleanPath.replace(/media\/media\//g, 'media/');
  }
  
  // If path already starts with media/, don't add it again
  if (cleanPath.startsWith('media/')) {
    return `${baseURL}/${cleanPath}`;
  }
  
  // Otherwise, add media/ prefix
  return `${baseURL}/media/${cleanPath}`;
};

// Utility function to get quality-based audio URL from API
/**
 * Get the dashboard route for a given user type
 * @param {string} userType - The user type ('creator', 'podcaster', 'label', 'publisher', etc.)
 * @returns {string} The dashboard route for the user type
 */
// Public profile page for any account, by its type. Accounts are keyed by
// uuid; creators use their slug when they have one.
export const getPublicProfileRoute = (account) => {
  if (!account) return AppRoutes.Home2;
  const id = account.uuid || account.id;
  switch (account.user_type) {
    case 'creator':
      return AppRoutes.PublicCreatorProfile.replace(':slug', account.slug || id);
    case 'label':
      return AppRoutes.PublicLabelProfile.replace(':id', id);
    case 'publisher':
      return AppRoutes.PublicPublisherProfile.replace(':id', id);
    case 'podcaster':
      return AppRoutes.PublicPodcasterProfile.replace(':id', id);
    default:
      return AppRoutes.PublicListenerProfile.replace(':id', id);
  }
};

export const getDashboardRoute = (userType) => {
  const dashboardRoutes = {
    creator: AppRoutes.CreatorDash,
    podcaster: AppRoutes.PodcasterDash,
    label: AppRoutes.LabelDash,
    label_team_member: AppRoutes.LabelDash,
    publisher: AppRoutes.PublisherDash,
    listener: AppRoutes.Home2, // Listeners don't have a dedicated dashboard
  };
  
  return dashboardRoutes[userType] || AppRoutes.Home2;
};

export const getQualityAudioUrl = async (trackId) => {
  try {
    const token = localStorage.getItem('token');
    const searchParams = new URLSearchParams(window.location.search);
    let linkToken = searchParams.get('link_token');
    
    // If not in URL, check sessionStorage for private album/track tokens
    if (!linkToken) {
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key && (key.startsWith('private_album_token_') || key.startsWith('private_track_token_'))) {
          linkToken = sessionStorage.getItem(key);
          if (linkToken) break;
        }
      }
    }
    
    if (!token && !linkToken) {
      console.warn('No auth token or private link token found, falling back to direct audio URL');
      return null;
    }

    // Create an AbortController for timeout
    const controller = new AbortController();
    // Reduced timeout to 2 seconds - if quality URL takes longer, use direct URL
    const timeoutId = setTimeout(() => controller.abort(), 2000);
    
    const headers = {
      'Content-Type': 'application/json',
    };
    
    if (token) {
      headers['Authorization'] = `Token ${token}`;
    } else if (linkToken) {
      headers['X-Private-Link-Token'] = linkToken;
    }
    
    const url = linkToken 
      ? `${apiBaseURL}/music/track/${trackId}/audio/?link_token=${encodeURIComponent(linkToken)}`
      : `${apiBaseURL}/music/track/${trackId}/audio/`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: headers,
      signal: controller.signal,
    });
    
    clearTimeout(timeoutId);
    
    if (response.ok) {
      const data = await response.json();
      return getAudioUrl(data.audio_url);
    } else {
      return null;
    }
  } catch (error) {
    // Silently fail - direct URL will be used
    return null;
  }
};

export const ApiRoutes = buildApiRoutes(apiBaseURL);

